import { FuseUtils } from '@fuse/utils';

export class List {
    id: string;
    name: string;
    description?: string;
    idCards: string[];

    constructor(list: any) {
        this.id = list.id || FuseUtils.generateGUID();
        this.name = list.name || '';
        this.description = list.description || '';
        this.idCards = [];
    }
}
